var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 40,
    viewBox: "0 0 149 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.548 0L20.3066 29.8298L3.06514 0.0425542V0H0V39.9574H3.61857V7.74468L19.3274 34.766H21.2006L36.952 7.65957L36.9946 39.9149V39.9574H40.6131L40.5706 0.0851067V0H37.548Z",
    fill: "#D2C5B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2524 0V32.2128L76.5435 5.23404H74.6704L58.9615 32.3404L58.8764 0.0851067V0H55.2578L55.3004 39.9149V39.9574H58.323L75.5644 10.1702L92.8058 39.9574H95.871V0H92.2524Z",
    fill: "#D2C5B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.126 0V18H114.517V0H110.813V39.9574H114.517V21.3617H145.126V39.9574H148.83V0H145.126Z",
    fill: "#D2C5B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.548b7fde1c03c7a3c0717b0fd8a08d7f.svg";
export { ForwardRef as ReactComponent };